import countries from "../../../data/countries.json";

const typeModeOptions = [
  { label: "Pending", value: "pending" },
  { label: "Success", value: "SUCCESS" },
];

const coverTypeOptions = [
  { label: "Domestic", value: "Domestic" },
  { label: "International", value: "International" },
];

const purchaseMethodOptions = [
  { label: "Quote Link", value: "LINK" },
  { label: "Dashboard", value: "BULK" },
  { label: "Website", value: "online" },
];

export const filterOptions = [
  {
    label: "Purchase Method",
    value: "purchase_method",
    type: "checkbox",
    multiple: true,
    options: purchaseMethodOptions,
    roles: ["is_superuser"],
  },
  {
    label: "Cover Type",
    value: "cover_type",
    type: "checkbox",
    multiple: true,
    options: coverTypeOptions,
    roles: ["is_superuser"],
  },
  {
    label: "Status",
    value: "status",
    type: "checkbox",
    multiple: true,
    options: typeModeOptions,
    roles: ["is_superuser"],
  },
  {
    value: "traveller_to",
    label: "Traveller To",
    type: "select",
    options: countries,
    roles: ["is_superuser"],
  },
  {
    value: "traveller_from",
    label: "Traveller From",
    type: "select",
    options: countries,
    roles: ["is_superuser"],
  },
  {
    value: "date_range",
    label: "Date Range",
    type: "date-range",
    options: null,
    roles: ["is_superuser"],
  },
];

export const sortOptions = [
  {
    label: "Sort By",
    value: "ordering",
    type: "checkbox",
    multiple: false,
    options: [
      { label: "Updated On", value: "updated_on" },
      { label: "Created On", value: "created_on" },
      { label: "Coverage Start Date", value: "coverage_start_date" },
      { label: "Coverage End Date", value: "coverage_end_date" },
      { label: "Total Amount", value: "total_amount" },
      { label: "No. of Pax", value: "no_of_pax" },
    ],
  },
];
